import { useGetSurchargeRelation } from 'queries';
import { isNil } from 'ramda';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';

import SurchargeRelationsForm from './SurchargeRelationsForm';
import { SurchargeRelationsSkeleton } from './SurchargeRelationsSkeleton';

const SurchargeRelations = ({ rowId, handleClose }: FormComponentProps) => {
  const { isFetching, data } = useGetSurchargeRelation(
    !isNil(rowId) ? Number(rowId) : rowId
  );

  if (isFetching) {
    return <SurchargeRelationsSkeleton />;
  }

  return (
    <SurchargeRelationsForm handleClose={handleClose} data={data ?? null} />
  );
};

export default SurchargeRelations;
